var _defs, _defs2, _defs3, _defs4;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIcons8Wrapping100(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "100px",
    height: "100px",
    style: {
      shapeRendering: "geometricPrecision",
      textRendering: "geometricPrecision",
      imageRendering: "optimizeQuality",
      fillRule: "evenodd",
      clipRule: "evenodd"
    },
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "dark-pink-gradient",
    x1: "0%",
    y1: "0%",
    x2: "100%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#ba3aff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#ff3a7f"
  })))), _defs2 || (_defs2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "white-gradient",
    x1: "0%",
    y1: "0%",
    x2: "100%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#bababa"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#fafafa"
  })))), _defs3 || (_defs3 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "light-pink-gradient",
    x1: "0%",
    y1: "0%",
    x2: "100%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#ec71ec"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#876bdb"
  })))), _defs4 || (_defs4 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "grey-gradient",
    x1: "0%",
    y1: "0%",
    x2: "100%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#404040"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#9b9b9b"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    id: "grey-border",
    style: {
      opacity: 1
    },
    fill: "black",
    d: "M 11.5,-0.5 C 13.8333,-0.5 16.1667,-0.5 18.5,-0.5C 25.3172,1.48567 29.6505,5.98567 31.5,13C 45.5936,13.0342 59.5936,13.7009 73.5,15C 74.7014,15.9025 75.5348,17.0692 76,18.5C 76.4998,29.495 76.6665,40.495 76.5,51.5C 78.7834,51.3921 80.7834,50.5588 82.5,49C 90.8438,47.5228 93.8438,51.0228 91.5,59.5C 94.2788,59.2786 96.9455,59.612 99.5,60.5C 99.5,65.1667 99.5,69.8333 99.5,74.5C 98.8501,74.8039 98.1835,75.1373 97.5,75.5C 96.5023,83.4723 96.169,91.4723 96.5,99.5C 68.1667,99.5 39.8333,99.5 11.5,99.5C 5.85894,97.1923 1.85894,93.1923 -0.5,87.5C -0.5,62.1667 -0.5,36.8333 -0.5,11.5C 1.85894,5.8077 5.85894,1.8077 11.5,-0.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    id: "yellow-cylinder",
    style: {
      opacity: 1
    },
    fill: "url(#dark-pink-gradient)",
    d: "M 27.5,12.5 C 27.8304,32.3404 27.4971,52.0071 26.5,71.5C 18.0142,65.5424 10.1809,66.209 3,73.5C 2.33333,53.1667 2.33333,32.8333 3,12.5C 6.9626,3.60722 13.4626,1.10722 22.5,5C 25.1998,6.85673 26.8665,9.35673 27.5,12.5 Z "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    id: "inner-cylinder-shading",
    style: {
      opacity: 1
    },
    fill: "#b19349",
    d: "M 27.5,12.5 C 28.6626,32.6625 28.8292,52.9958 28,73.5C 27.2828,72.9558 26.7828,72.2891 26.5,71.5C 27.4971,52.0071 27.8304,32.3404 27.5,12.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    id: "outer-cylinder-shading",
    style: {
      opacity: 1
    },
    fill: "#c0c0c0",
    d: "M 33.5,17.5 C 33.6666,40.8357 33.5,64.169 33,87.5C 32.2352,90.1959 31.0685,92.6959 29.5,95C 36.8258,95.4997 44.1591,95.6663 51.5,95.5C 51.5,88.8333 51.5,82.1667 51.5,75.5C 52.4912,82.3134 52.8245,89.3134 52.5,96.5C 43.4938,96.6664 34.4938,96.4998 25.5,96C 28.7544,93.6581 30.5877,90.4915 31,86.5C 30.8413,63.1449 31.6746,40.1449 33.5,17.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    id: "outer-cylinder-square",
    style: {
      opacity: 1
    },
    fill: "url(#white-gradient)",
    d: "M 33.5,17.5 C 46.1711,17.3334 58.8377,17.5001 71.5,18C 72.4874,29.0854 72.8207,40.252 72.5,51.5C 70.2166,51.3921 68.2166,50.5588 66.5,49C 58.1562,47.5228 55.1562,51.0228 57.5,59.5C 54.8806,59.2317 52.3806,59.565 50,60.5C 49.3333,65.1667 49.3333,69.8333 50,74.5C 50.3826,75.056 50.8826,75.3893 51.5,75.5C 51.5,82.1667 51.5,88.8333 51.5,95.5C 44.1591,95.6663 36.8258,95.4997 29.5,95C 31.0685,92.6959 32.2352,90.1959 33,87.5C 33.5,64.169 33.6666,40.8357 33.5,17.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    id: "left-bow",
    style: {
      opacity: 1
    },
    fill: "url(#light-pink-gradient)",
    d: "M 61.5,51.5 C 66.6131,51.4503 68.6131,53.9503 67.5,59C 68.1478,64.3462 65.8144,66.5129 60.5,65.5C 61.3136,60.8809 61.6469,56.2142 61.5,51.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    id: "right-bow",
    style: {
      opacity: 1
    },
    fill: "url(#light-pink-gradient)",
    d: "M 83.5,51.5 C 84.8333,51.5 86.1667,51.5 87.5,51.5C 87.5,56.1667 87.5,60.8333 87.5,65.5C 82.745,66.0219 80.745,63.8552 81.5,59C 81.3026,56.1755 81.9693,53.6755 83.5,51.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    id: "middle-bow",
    style: {
      opacity: 1
    },
    fill: "url(#light-pink-gradient)",
    d: "M 70.5,55.5 C 73.1667,55.5 75.8333,55.5 78.5,55.5C 78.5,57.8333 78.5,60.1667 78.5,62.5C 75.8333,62.5 73.1667,62.5 70.5,62.5C 70.5,60.1667 70.5,57.8333 70.5,55.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#828282",
    d: "M 57.5,63.5 C 56.1667,63.5 54.8333,63.5 53.5,63.5C 53.5,66.1667 53.5,68.8333 53.5,71.5C 52.5233,68.7131 52.19,65.7131 52.5,62.5C 54.4147,62.2155 56.0813,62.5489 57.5,63.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    id: "gift-box-cover",
    style: {
      opacity: 1
    },
    fill: "#f9f9f9",
    d: "M 57.5,63.5 C 57.7571,66.9245 59.5905,68.9245 63,69.5C 66.5642,67.4715 70.3975,66.1382 74.5,65.5C 77.9368,65.5521 80.9368,66.7187 83.5,69C 88.2103,70.1214 90.877,68.2881 91.5,63.5C 92.8333,63.5 94.1667,63.5 95.5,63.5C 95.5,66.1667 95.5,68.8333 95.5,71.5C 81.5,71.5 67.5,71.5 53.5,71.5C 53.5,68.8333 53.5,66.1667 53.5,63.5C 54.8333,63.5 56.1667,63.5 57.5,63.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    id: "outer-cylinder-radius",
    style: {
      opacity: 1
    },
    fill: "url(#dark-pink-gradient)",
    d: "M 12.5,70.5 C 25.7298,71.5311 30.2298,78.1978 26,90.5C 21.8604,95.2114 16.6938,96.7114 10.5,95C 3.92982,91.3449 1.76315,85.8449 4,78.5C 6.07383,74.9231 8.90716,72.2565 12.5,70.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#949494",
    d: "M 91.5,63.5 C 92.9187,62.5489 94.5853,62.2155 96.5,62.5C 96.5,65.8333 96.5,69.1667 96.5,72.5C 81.9903,72.8293 67.6569,72.4959 53.5,71.5C 67.5,71.5 81.5,71.5 95.5,71.5C 95.5,68.8333 95.5,66.1667 95.5,63.5C 94.1667,63.5 92.8333,63.5 91.5,63.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    id: "cylinder-outer-inner-demacation",
    style: {
      opacity: 1
    },
    fill: "#45413c",
    d: "M 12.5,74.5 C 24.5111,75.6857 27.1778,81.1857 20.5,91C 11.0805,93.919 6.58055,90.419 7,80.5C 8.35968,77.9774 10.193,75.9774 12.5,74.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    id: "gift-box",
    style: {
      opacity: 1
    },
    fill: "url(#dark-pink-gradient)",
    d: "M 55.5,75.5 C 68.1667,75.5 80.8333,75.5 93.5,75.5C 93.5,82.5 93.5,89.5 93.5,96.5C 80.8333,96.5 68.1667,96.5 55.5,96.5C 55.5,89.5 55.5,82.5 55.5,75.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    id: "inner-cylinder-radius",
    style: {
      opacity: 1
    },
    fill: "url(#white-gradient)",
    d: "M 12.5,78.5 C 20.4863,77.998 22.4863,81.1647 18.5,88C 10.424,88.8047 8.42402,85.638 12.5,78.5 Z"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcons8Wrapping100);
export default __webpack_public_path__ + "static/media/icons8-wrapping-100.205bd40c592da16846fe8f00f4567fcf.svg";
export { ForwardRef as ReactComponent };